import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ROUTE_PROFILE } from 'constants/urls';
import Navbar from 'components/Navbar';
import { GpdrWrapper } from './styles';

class Gpdr extends Component {
  componentDidMount() {
    this.setBreadcrumb();
  }

  setBreadcrumb = () => {
    const {
      history, literals, setBreadcrumb, resetContext,
    } = this.props;

    const breadcrumb = [
      {
        color: '#ffffff',
        text: literals.profile,
        onClick: () => {
          history.push(ROUTE_PROFILE);
        },
      },
      {
        color: '#ffffff',
        text: literals.title,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
    resetContext();
  }

  render() {
    const { user: { id, user_code: userCode }, color, literals } = this.props;
    const url = `https://calltoinnovation.org/configuration_gdpr.php?h=true&clean=true&session_user=${id}&session_code=${userCode}`;
    return (
      <GpdrWrapper color={color}>
        <Navbar />
        <iframe src={url} title={literals.title} />
      </GpdrWrapper>
    );
  }
}

Gpdr.propTypes = {
  user: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  setBreadcrumb: PropTypes.func.isRequired,
  resetContext: PropTypes.func.isRequired,
};

export default Gpdr;



// WEBPACK FOOTER //
// ./src/routes/Gpdr/components/Gpdr.jsx